import React from 'react'

const UserErrorPage = () => {
  return (
    <div>UserErrorPage</div>
  )
}

export default UserErrorPage